import { render, staticRenderFns } from "./Destinationlistdetails.vue?vue&type=template&id=2d961e72&scoped=true&"
import script from "./Destinationlistdetails.vue?vue&type=script&lang=js&"
export * from "./Destinationlistdetails.vue?vue&type=script&lang=js&"
import style0 from "./Destinationlistdetails.vue?vue&type=style&index=0&id=2d961e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d961e72",
  null
  
)

export default component.exports